import api from './api'

export const mfaAPI = {
  // Get MFA status
  getStatus: () => api.get('/mfa/status'),
  
  // Setup MFA (generate secret and QR code)
  setup: () => api.post('/mfa/setup'),
  
  // Verify and enable MFA
  verify: (token) => api.post('/mfa/verify', { token }),
  
  // Disable MFA
  disable: () => api.post('/mfa/disable'),
  
  // Regenerate backup codes
  regenerateBackupCodes: () => api.post('/mfa/regenerate-backup-codes'),
  
  // Verify MFA during login
  verifyLogin: (sessionToken, token, backupCode) => {
    const body = { session_token: sessionToken };
    if (token) {
      body.token = token;
    } else if (backupCode) {
      body.backup_code = backupCode;
    }
    return api.post('/mfa/verify-login', body);
  },
  
  // Complete login after MFA verification
  completeLogin: (sessionToken) => api.post('/auth/complete-login', { session_token: sessionToken })
}

